export default __webpack_public_path__ + "static/fluo-pentagram-b39c4fe87c4895c0f55d91351f7b5955.png";